import { useState } from 'react'
import './App.css'
import SGPACalculator from './components/SGPACalculator'
import Header from './components/Header'
import { Analytics } from '@vercel/analytics/react'

function App() {
  return (
    <div className="app">
      <Header />
      <main className="main-content">
        <SGPACalculator />
      </main>
      {process.env.NODE_ENV === 'production' && <Analytics />}
    </div>
  )
}

export default App
